import * as Common from "../../commons/common"

export class Student {
  user_id: number
  login_id: string
  student_num: number
  name: string
  nendo: number
  grade: number
  room_name: string
  number: number
  at_full_count: number

  constructor(student: any){
    this.user_id = student.id;
    this.login_id = student.login_id;
    this.student_num = student.student_num;
    this.name = student.name;
    this.nendo = student.nendo;
    this.grade = student.grade_id;
    this.room_name = student.room_name;
    this.number = student.number;
    this.at_full_count = student.at_full_count;
  }
}

export class StudentListCondition{
  student_num: string = ""
  login_id: string = ""
  name: string = ""
  nendo: string = ""
  grade: string = ""
  page: number = 1
  row_count: number =  Common.StudentListRowCount
}

export class PasswordForm {
  user_id: number
  login_id: string
  name: string
  password: string = ""
  password_confirmation: string = ""

  constructor(student: Student){
    this.user_id = student.user_id;
    this.login_id = student.login_id;
    this.name = student.name;
  }
}